import React, { useEffect, useState, useRef } from 'react';
import { LuMail, LuMapPin, LuPhoneCall } from 'react-icons/lu';

const BottomNav = () => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(window.scrollY); // Store the last scroll position persistently

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        // Scrolling down
        setIsVisible(false);
      } else {
        // Scrolling up
        setIsVisible(true);
      }
      lastScrollY.current = window.scrollY; // Update last scroll position
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // No need for dependencies here

  return (
    <div className={`bottom-nav ${isVisible ? "" : "hidden"}`}>
      <a href='mailto:contact@levelcontractor.com' className="bottom-nav-item">
        <span className="icon"><LuMail /> </span>
        <span>Email</span>
      </a>
      <a href="tel:+18182972920" className="bottom-nav-item">
        <span className="icon"><LuPhoneCall /></span>
        <span>Call</span>
      </a>
      <a href="https://maps.app.goo.gl/J2JBJhztt9r3ANSp7" target="_blank" rel="noopener noreferrer" className="bottom-nav-item">
        <span className="icon"> <LuMapPin /> </span>
        <span>Reach Us</span>
      </a>
    </div>
  );
};

export default BottomNav;
